
const WhatsAppButton = () => {
  return (
    <>
      <a
        href="https://wa.me/34602365996"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all animate-pulse-slow cursor-pointer hidden md:flex"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
      </a>

      <div className="fixed bottom-0 left-0 right-0 z-50 bg-white shadow-lg md:hidden">
        <div className="grid grid-cols-2 gap-0">
          <a
            href="tel:+34602365996"
            className="flex items-center justify-center py-4 bg-primary text-white font-semibold cursor-pointer hover:bg-primary-dark transition-colors"
          >
            <i className="ri-phone-line text-xl mr-2"></i>
            Llamar
          </a>
          <a
            href="https://wa.me/34602365996"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center py-4 bg-[#25D366] text-white font-semibold cursor-pointer hover:bg-[#20BA5A] transition-colors"
          >
            <i className="ri-whatsapp-line text-xl mr-2"></i>
            WhatsApp
          </a>
        </div>
      </div>
    </>
  );
};

export default WhatsAppButton;
